import React from "react";
import { Link } from "react-router-dom";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import localeText from "../../../../../../locale";
import { formatPrice } from "../../../../../../utilities/formatPrice";
import { EXTRAPAY_CYCLE_PATH } from "../constants";
import { formatExtrapayDateTime } from "../formatExtrapay";
import ExtrapayDetailRows from "./ExtrapayDetailRows";
import ExtrapayDialogHeading from "./ExtrapayDialogHeading";
import ExtrapayStatusBadge from "./ExtrapayStatusBadge";

export const getConversionTitle = (conversion) =>
  conversion?.cycle != null
    ? localeText("extrapayFlowConversionTitle", { cycle: conversion.cycle })
    : localeText("extrapayFlowConversionFallback");

export const formatConversionExc = (amount, { signed = false } = {}) => {
  if (amount == null) return localeText("extrapayFlowUnavailable");
  const formatted = formatPrice(amount);
  return signed
    ? localeText("extrapayFlowSignedExc", { amount: formatted })
    : localeText("extrapayFlowExcAmount", { amount: formatted });
};

export const formatConversionPoints = (amount) => {
  if (amount == null) return localeText("extrapayFlowUnavailable");
  return formatPrice(amount);
};

const ConversionDetailsDialog = ({ conversion, onHide }) => {
  if (!conversion) return null;

  const status = conversion.converted
    ? { labelKey: "extrapayFlowStatusConfirmed", tone: "success" }
    : conversion.open
      ? { labelKey: "extrapayFlowStatusInProgress", tone: "warning" }
      : { labelKey: "extrapayFlowStatusNotConverted", tone: "neutral" };

  return (
    <Dialog
      visible
      onHide={onHide}
      draggable={false}
      className="extrapay-flow-dialog"
      style={{ width: "min(520px, 96vw)" }}
      header={
        <ExtrapayDialogHeading
          title={getConversionTitle(conversion)}
          subtitle={localeText("extrapayFlowBasicData")}
        />
      }
    >
      <ExtrapayStatusBadge labelKey={status.labelKey} tone={status.tone} />
      <div className="mt-3">
        <ExtrapayDetailRows
          rows={[
            {
              label: localeText("extrapayFlowReference"),
              value: conversion.reference,
            },
            {
              label: localeText("extrapayFlowQuantity"),
              value: formatConversionExc(conversion.tokensReceived, { signed: true }),
            },
            {
              label: localeText("extrapayFlowDate"),
              value: formatExtrapayDateTime(conversion.date),
            },
          ]}
        />
      </div>
      <Link to={EXTRAPAY_CYCLE_PATH}>
        <Button
          label={localeText("extrapayFlowViewFullConversion")}
          className="mt-4 border-round-md border-none"
          style={{ backgroundColor: "var(--theme-primary, #1DAF61)", color: "#fff" }}
        />
      </Link>
    </Dialog>
  );
};

export default ConversionDetailsDialog;
